package com.bkahlert.hello.font

public object FontFamilies {
    public const val SYSTEM_UI: String = "" +
        "system-ui," +
        "-apple-system," +
        "BlinkMacSystemFont," +
        "'Segoe UI'," +
        "Roboto," +
        "Helvetica," +
        "Arial," +
        "sans-serif," +
        "'Apple Color Emoji'," +
        "'Segoe UI Emoji'"

    public const val MONOSPACE: String = "" +
        "ui-monospace," +
        "SFMono-Regular," +
        "Menlo," +
        "Monaco," +
        "Consolas," +
        "'Liberation Mono'," +
        "'Courier New'," +
        "monospace"
}
